<template>
  <div class="sidebar-toggle">
    <el-button type="text" :class="[open ? 'active' : '', 'button']" @click="handleClick">
      <unicon v-if="open" name="times" fill="#181C28"></unicon>
      <unicon v-else name="align-left" fill="#181C28"></unicon>
      <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 128 128" style="enable-background:new 0 0 128 128;" xml:space="preserve" width="128px" height="128px">
        <g class="top-line">
          <path d="M86.5,52h-45c-1.7,0-3-1.3-3-3s1.3-3,3-3h45c1.7,0,3,1.3,3,3S88.2,52,86.5,52z"/>
        </g>
        <g class="mid-line">
          <path d="M86.5,67h-45c-1.7,0-3-1.3-3-3s1.3-3,3-3h45c1.7,0,3,1.3,3,3S88.2,67,86.5,67z"/>
        </g>
        <g class="mid-line-2">
          <path d="M86.5,67h-45c-1.7,0-3-1.3-3-3s1.3-3,3-3h45c1.7,0,3,1.3,3,3S88.2,67,86.5,67z"/>
        </g>
        <g class="bottom-line">
          <path d="M86.5,82h-45c-1.7,0-3-1.3-3-3s1.3-3,3-3h45c1.7,0,3,1.3,3,3S88.2,82,86.5,82z"/>
        </g>
      </svg> -->
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'sidebar-toggle',
  computed: {
    open () {
      return this.$store.getters.sidebar.opened
    }
  },
  methods: {
    handleClick () {
      this.$store.dispatch('toggleSideBar')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/settings.scss";
.sidebar-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
}
// .button {
//   border: 0;
//   padding: 0;
//   height: 50px;
//   width: 50px;
//   border-radius: 50%;
//   background-color: transparent;
//   color: $black-color;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   line-height: 0;
//   transition: transform 300ms ease-out, border-color 300ms ease-out;
// }
// .button svg {
//   height: 100%;
//   width: 100%;
//   fill: $black-color;
//   transition: all 100ms ease-out;
// }
// .button .top-line, .button .bottom-line{
//   visibility: visible;
//   transition: all 300ms ease-out;
// }
// .button .mid-line, .button .mid-line-2{
//   transform-origin: center;
//   transition: transform 300ms ease-out;
// }
//
// .button:focus{
//   outline: none;
// }
// .button svg:hover {
//   fill: $orange-color;
//   transition: all 100ms ease-out;
// }
//
// .active{
//   // transform: rotate(45deg);
// }
//
// .active svg{
//   fill: $black-color;
// }
// .active .top-line, .active .bottom-line {
//   visibility: hidden;
//   transition: all 50ms ease-out;
// }
// .active .mid-line {
//   transform: rotate(45deg);
//   transform-origin: center;
// }
// .active .mid-line-2 {
//   transform: rotate(-45deg);
//   transform-origin: center;
// }
</style>



// WEBPACK FOOTER //
// src/components/SidebarToggle.vue